/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Manager_User_CountInputs */



/**
* | output |
* | --- |
* | "{count} user(s)" |
*
* @param {Team_Manager_User_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_user_count = /** @type {((inputs: Team_Manager_User_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_User_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} utilisateur(s)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Benutzer(n)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} utente(i)`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Пользователь(и) ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} usuario(s)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 用户`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} ユーザー`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} उपयोगकर्ता(ओं)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} usuário(s)`)
	return /** @type {LocalizedString} */ (`${i?.count} user(s)`)
});